<template>
  <div>
    <div class="p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ManagerReviewCompetence",
  data() {
    return {
      columns: [
        {
          field: "Competency",
          key: "a",
          title: "Competency",
        },
        { field: "DueDate", key: "b", title: "Due Date" },
        {
          field: "Attachment",
          key: "c",
          title: "Attachment",
          renderBodyCell: () => {
            return <p class="cursor-pointer font-bold">&#128206;</p>;
          },
        },
        { field: "EmployeeReview", key: "ddd", title: "Employee Review" },
        { field: "MyReview", key: "d", title: "MyReview" },
        { field: "Feedback", key: "e", title: "Feedback" },
      ],
      tableData: [
        {
          Competency: "Agility",
          DueDate: "15 Dec 2022",
          Attachment: "",
          EmployeeReview: "50%",
          MyReview: "98%",
          Feedback: "",
        },
      ],
    };
  },
};
</script>
